export * from '../../../../common/src/components/Icon';